module.exports = __webpack_public_path__ + "img/pdf-overlay.8cc2bcc9.png";